import { ia } from 'lib/helpers/utility';

import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import Button from 'components/shared/Button/Button';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Divider from 'components/shared/Divider/Divider';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

import { Caption } from '../../PayWithCardModal/SavedCards';
import { handleCardIcon } from '../../lib/helpers';

const SavedCards = ({ cards, active, setActive }) => {
  const { handlePayment, setFieldValue, setSelectedTerminal } = usePaymentContextApi();
  const { terminalData, processor } = usePaymentContext();

  const onToggle = (id) => setFieldValue('methodDetail', id);

  const handleCardClickHandler = async () => {
    setSelectedTerminal(terminalData?.onlineTerminal);
    if (processor === 'payroc') {
      setActive('credit-card');
      return;
    }
    await handlePayment();
  };

  return (
    <div className="flex w-full flex-col items-center justify-center gap-8">
      {ia(cards) && (
        <>
          <div className="flex max-h-[300px] w-full flex-col gap-2  overflow-y-auto p-2">
            {cards.map((card) => {
              const isActive = active === card.id;
              return (
                <Disclosure
                  key={card.id}
                  isOpen={isActive}
                  icon={<Icon icon={handleCardIcon(card.kind)} size="" />}
                  onToggle={(open) => onToggle(open ? card.id : null)}
                  disableOpen
                  caption={<Caption card={card} />}
                  bodyClassName="flex-col"
                  buttonClassName="py-2.5"
                  className="flex-shrink-0"
                  customTitle={
                    <Typography variant="label" size="medium">
                      {card.name}
                    </Typography>
                  }
                />
              );
            })}
          </div>
          <Divider className="w-full" color="neutral-200" text="OR" />
        </>
      )}
      {terminalData?.onlineTerminal && (
        <Button
          text="Enter Card Manually"
          icon="credit-card-income-mono"
          variant="tertiary"
          size="small"
          color="neutral"
          iconShade={700}
          onClick={handleCardClickHandler}
        />
      )}
    </div>
  );
};

export default SavedCards;
